const data = {
  'error.Unauthorized': 'Unauthorized',
  'error.generic': 'Something Went Wrong!',
  'error.server': 'Something unexpected has occured. Please try again later.',
  'error.server.403':
    'You do not have sufficient permissions to view this page.',
}
export default data
